'use strict';

import $ from 'jquery';

export default class SiteHeaderNew {
  constructor($selector = $('.site-header'), selfInit = true) {
		this.$selector = $selector;
		this.isMobileView = $(window).width() < 1024 ? true : false; 

		this.isMobile = false; //initiate as false

		// device detection
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
		  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
		  this.isMobile = true;
		}

    if(selfInit) this.init();
  }

  init() {
		if (this.isMobile) {
			this.$selector.addClass('is-mobile');
			$('.flyer-search').addClass('is-mobile');
		}

		$('.site-header__button--search', this.$selector).on('click', (e) => {
			e.preventDefault();

			this.toggleSearch();
		});

		this.initSearchFlyout();

		$('.site-header__button--menu', this.$selector).on('click', (e) => {
			e.preventDefault();

			this.openMenu();
		});

		$('.site-header__button--close-menu', this.$selector).on('click', (e) => {
			e.preventDefault();

			this.closeMenu();
		});

		$('.site-header__level1 > li > button', this.$selector).map((i,ele) => {
			$(ele).on('click', (e) => {
				e.preventDefault();
				
				this.goToNextLevel($(ele).next());
			});
		});

		$('.site-header__megamenu', this.$selector).map((i,ele) => {
			$(ele).on('mouseenter', () => {
				$('body').addClass('fixed');
			});
			
			$(ele).on('mouseleave', () => {
				$('body').removeClass('fixed');
			});
		});

		$('.site-header__megamenu > button', this.$selector).map((i,ele) => {
			$(ele).on('click', (e) => {
				e.preventDefault();
				
				this.goToPrevLevel($(ele).parent());
			});
		});

		$('.site-header__level2 > li > button', this.$selector).map((i,ele) => {
			$(ele).on('click', (e) => {
				e.preventDefault();
				
				this.toggleNextLevel($(ele).next());
			});
		});

		$('.site-header__global button', this.$selector).on('click', (e) => {
			e.preventDefault();

			if (!$('.regional-selector').hasClass('active')) {
				$('.regional-selector').addClass('active');
				$('body').addClass('fixed');
			}
			else {
				return;
			}
		});

		if($('.site-header__megamenu__col header button', this.$selector).length) {
			$('.site-header__megamenu__col header button', this.$selector).map((i,ele) => {
				$(ele).on('click', (e) => {
					e.preventDefault();

					this.toggleNextLevel($(ele).parent().next());
				});
			});
		}

		$(window).on('resize', () => {
			if($(window).width() > 1023) {
				if(this.isMobileView) {
					this.clearState();
					this.isMobileView = false;
				}
			}
			else {
				if(!this.isMobileView) {
					this.isMobileView = true;
				}
			}
		});

		$(document).on('click.closeMenu', (e) => {
      const $eTarget = $(e.target);

      if (!(
          $eTarget.hasClass('site-header') ||
          $eTarget.parents('.site-header').length
        )) {
        this.closeMenu();
      }
    });
  }

	initSearchFlyout() {
		$('.flyer-search .flyer-search__ctas button').on('click', (e) => {
			e.preventDefault();

			$('.flyer-search').removeClass('active');
		});
	}

	toggleSearch() {
		if(!$('.flyer-search').hasClass('active')) {
			$('.flyer-search').addClass('active');
		}
		else {
			$('.flyer-search').removeClass('active');
		}
	}

	openMenu() {
		$('.site-header__body--left', this.$selector).addClass('active');
		$('body').addClass('fixed');
	}
	
	closeMenu() {
		$('.site-header__body--left', this.$selector).removeClass('active');
		$('body').removeClass('fixed');
	}

	goToNextLevel($nextLevel) {
		$nextLevel.addClass('active');
	}

	goToPrevLevel($prevLevel) {
		$prevLevel.removeClass('active');
	}

	toggleNextLevel($nextLevel) {
		if(!$nextLevel.hasClass('active')) {
			$nextLevel.slideDown(300);
			$nextLevel.addClass('active');
		}
		else {
			$nextLevel.slideUp(300);
			$nextLevel.removeClass('active');
		}
	}

	clearState() {
		$('.active', this.$selector).removeClass('active')
	}
}
